module.exports = __webpack_public_path__ + "img/home-5.703c1cbc.png";